import { ConnectFbSplashScreenLayout } from '../../../Layouts/ConnectFbSplashScreenLayout';
import { Layout } from '../../../Utility/layout/createLayout';
import BaseMenu from 'System/UI/Menu/BaseMenu';
import BaseUISystem from 'System/UI/BaseUISystem';
import { PopupID } from 'State/UI/PopupID';
import Game from 'Game';
import { Anim, AnimFrom } from 'System/Animation/AnimationHelper';
import { GameObjectEvent } from 'GameObject/GameObject';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { UIActions } from 'State/UI/UIActions';
import Renderable from 'Component/Renderable';
import TransformComponent from 'Component/Transform';
import RenderSystem, { RenderSystemEvent } from 'System/Render/RenderSystem';
import PIXIRenderer from 'System/Render/PIXIRenderer';
import { PlatformActions } from 'State/Game/PlatformActions';
import { isNative } from 'Utility/Platform';
import { AuthPlatform } from '@sgorg/mobile-dev-tools';
import { IGameState } from 'State/Game/IGameState';

export class ConnectFbSplashScreen extends BaseMenu {
    private layout: any;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.CONNECT_FB_SPLASH_SCREEN, uiSystem, false);

        this.clipShow = 'AnimationClip';
        this.clipHide = 'AnimationClip';
    }

    public static shouldShow(state: IGameState): boolean {
        const { levels } = state.playerState;
        return isNative() && levels.core.length === 0;
    }

    public async preload(): Promise<void> {
        Game.resource.add('splash_screen_fb_logo', 'resource/graphics/other/splash_screen_fb_logo.jpg');
        await super.preload();
    }

    public onCreate() {
        super.onCreate();

        this.layout = new ConnectFbSplashScreenLayout();
        this.element.addChild(this.layout.root);
        this.element.container.resize = () => void 0;

        this.layout.playButton.on(GameObjectEvent.SELECTED, this.handlePlayClick);
        this.layout.connectButton.on(GameObjectEvent.SELECTED, this.handleConnectClick);

        [this.layout.playButton, this.layout.connectButton].forEach(button => {
            applyDefaultButtonAnimation(button);
        });

        this.element.getComponent(Renderable).visible = true;
        AnimFrom(this.layout.root, { alpha: 0, duration: 500 });

        RenderSystem.on(RenderSystemEvent.RESIZE, this.handleResize);
        this.handleResize();
    }

    protected onHide(params?: any): void {
        super.onHide(params);
        Anim(this.layout.root, { alpha: 0, duration: 300 });
        RenderSystem.off(RenderSystemEvent.RESIZE, this.handleResize);
    }

    private readonly handlePlayClick = (): void => {
        UIActions.hidePopup(PopupID.CONNECT_FB_SPLASH_SCREEN);
    };

    private readonly handleConnectClick = async (): Promise<void> => {
        Game.store.dispatch(PlatformActions.signIn(AuthPlatform.Facebook, true));
    };

    private readonly handleResize = (): void => {
        this.layout.root.getComponent(TransformComponent).x = PIXIRenderer.renderer.width / 2;
        const bgTransform = this.layout.bg.getComponent(TransformComponent);

        bgTransform.scale.set(
            Math.max(
                PIXIRenderer.renderer.width / bgTransform.width,
                PIXIRenderer.renderer.height / bgTransform.height
            ) * bgTransform.scale.x
        );

        const buttonsTransform = this.layout.buttonsContainer.getComponent(TransformComponent);
        buttonsTransform.y = PIXIRenderer.renderer.height * 0.75;
    };
}
